import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DialogConfirmacao = ({
  visible,
  message,
  titulo = "Confirmar",
  icon = "pi-question-circle",
  iconColor = "#ef4444",
  onConfirm,
  onCancel,
  textoConfirmar = "SIM",
  textoCancelar = "NÃO",
}) => {
  // Cor do ícone baseada no tipo
  const getIconColor = () => {
    if (icon === "pi-shopping-cart") return "#B83732";
    if (icon === "pi-print") return "#3B82F6";
    if (icon === "pi-check-circle") return "#22C55E";
    return iconColor;
  };

  const getIconBgColor = () => {
    const color = getIconColor();
    return `${color}20`; // 20% opacity
  };

  return (
    <Dialog
      visible={visible}
      style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
      onHide={onCancel}
      draggable={false}
      closable={false}
      header={null}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: getIconBgColor(),
            color: getIconColor(),
          }}
        >
          <i className={`pi ${icon}`} style={{ fontSize: "2.5rem" }}></i>
        </div>
        
        {titulo && (
          <h3
            style={{
              margin: 0,
              fontSize: "1.2rem",
              fontWeight: "600",
              color: "#2d3748",
            }}
          >
            {titulo}
          </h3>
        )}
        
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
          }}
        >
          {message}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          <Button
            label={textoCancelar}
            icon="pi pi-times"
            onClick={onCancel}
            className="p-button-outlined p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              borderColor: "#dee2e6",
              color: "#495057",
              fontWeight: "500",
              fontSize: "0.875rem",
              borderRadius: "8px",
            }}
          />
          <Button
            label={textoConfirmar}
            icon="pi pi-check"
            onClick={onConfirm}
            className="p-button-success p-button-sm"
            style={{
              outline: "none",
              boxShadow: "none",
              padding: "8px 24px",
              minWidth: "100px",
              fontWeight: "500",
              fontSize: "0.875rem",
              borderRadius: "8px",
              backgroundColor: getIconColor(),
              borderColor: getIconColor(),
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DialogConfirmacao;